export default __webpack_public_path__ + "static/media/residelly-single-logo.cf202470.svg";